module.exports = __webpack_public_path__ + "static/media/5.26383a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/5.png
// module id = 1189
// module chunks = 0